module.exports = __webpack_public_path__ + "img/avatar.354a2c81.png";